import { createEscolaRoute, escolaEditRoute, newPeriodoCoopRoute, newPeriodoJornadaRoute, newPeriodoRoute } from "library/Routes";
import { ESCOLA_ETAPAS_PARAMS_URL } from "models/escola";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { TipoPrograma } from "store/modules/EscolasTypes";
import { EscolaEditTabs } from "../__enum";
import { useHistory, useLocation } from "react-router-dom";
import SnackbarUtils from '../../../../../../utils/SnackbarUtils';
import { useCallback, useMemo } from "react";
import { Modo, TITULOS } from "../__types";

export default function useProgramas() {
    const languageValues = useSelector((state: RootState) => state.languages.languageValues);
    const location = useLocation();
    const history = useHistory();

    const cadastroEscola = useMemo(() => location.pathname.includes(ESCOLA_ETAPAS_PARAMS_URL.CADASTRO), [location.pathname]);
    const cadastroPeriodo = useMemo(() => location.pathname.includes(ESCOLA_ETAPAS_PARAMS_URL.PERIODO_CADASTRO), [location.pathname]);
    const edicaoPeriodo = useMemo(() => location.pathname.includes(ESCOLA_ETAPAS_PARAMS_URL.EDITAR), [location.pathname]);
    const duplicacaoPeriodo = useMemo(() => location.pathname.includes(ESCOLA_ETAPAS_PARAMS_URL.DUPLICAR), [location.pathname]);

    const programaNomes: Record<TipoPrograma, string> = {
        [TipoPrograma.UniaoFazAVida]: 'A União Faz a Vida',
        [TipoPrograma.CooperativaEscolar]: 'Cooperativas Escolares',
        [TipoPrograma.JornadaEducacao]: 'Jornada da Educação Financeira nas Escolas',
    };

    const getNomePrograma = (tipo: string): string => {
        return programaNomes[tipo as TipoPrograma] || 'Programa desconhecido';
    };

    const titleMap = {
        duplicar: {
            [TipoPrograma.UniaoFazAVida]: languageValues.duplicarPeriodoTitlePufv,
            [TipoPrograma.CooperativaEscolar]: languageValues.duplicarPeriodoTitleCooperativa,
            [TipoPrograma.JornadaEducacao]: languageValues.duplicarPeriodoTitleJornada,
        },
        editar: {
            [TipoPrograma.UniaoFazAVida]: languageValues.editPeriodoTitlePufv,
            [TipoPrograma.CooperativaEscolar]: languageValues.editPeriodoTitleCoop,
            [TipoPrograma.JornadaEducacao]: languageValues.editPeriodoTitleJornada,
        },
        novo: {
            [TipoPrograma.UniaoFazAVida]: languageValues.newPeriodoTitle,
            [TipoPrograma.CooperativaEscolar]: languageValues.newPeriodoTitleCoop,
            [TipoPrograma.JornadaEducacao]: languageValues.newPeriodoTitleJornada,
        },
    };

    const getTitleModal = (tipoPrograma: string | number) => {
        const tipo = tipoPrograma.toString() as TipoPrograma;

        if (duplicacaoPeriodo) return titleMap.duplicar[tipo] || '';
        if (edicaoPeriodo) return titleMap.editar[tipo] || '';
        return titleMap.novo[tipo] || '';
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const validationKeyMap: Record<TipoPrograma, string> = {
        [TipoPrograma.UniaoFazAVida]: 'periodoEditing',
        [TipoPrograma.CooperativaEscolar]: 'periodoEditingCoop',
        [TipoPrograma.JornadaEducacao]: 'periodoEditingJornada',
    };

    const getPeriodoValidationKey = useCallback((tipoPrograma: TipoPrograma): string => {
        return validationKeyMap[tipoPrograma] || 'periodoEditing';
    }, [validationKeyMap]);
    
    const retornaListaPeriodos = (idParam: string) => {
        const tab = EscolaEditTabs.ProgramasEducacionais;
        if (cadastroEscola) {
            const url = createEscolaRoute.getURLWithParams(idParam, tab);
            history.push(url);
        } else {
            const url = escolaEditRoute.getURLWithParams(idParam, tab);
            history.push(url);
        }
    }

    const rotaPeriodoModal = (tipoProgramaParam: TipoPrograma, idParam: string) => {
        const routeMap = {
            [TipoPrograma.UniaoFazAVida]: newPeriodoRoute,
            [TipoPrograma.CooperativaEscolar]: newPeriodoCoopRoute,
            [TipoPrograma.JornadaEducacao]: newPeriodoJornadaRoute,
        };
        const route = routeMap[tipoProgramaParam];
        if (!route) {
            SnackbarUtils.enqueueSnackbar({
                message: 'Tipo de programa não reconhecido. Por favor, tente novamente.',
                options: { variant: 'error' },
            });
            return;
        }
        history.push(route.getURLWithParams(idParam));
    };

    const useTituloModal = () => {
        return useMemo(() => {
            let modo: Modo;

            if (duplicacaoPeriodo) {
                modo = 'duplicar';
            } else if (edicaoPeriodo) {
                modo = 'edicao';
            } else {
                modo = 'cadastro';
            }
            return TITULOS[modo];
        }, []);
    };

    return {
        getNomePrograma,
        getTitleModal,
        getPeriodoValidationKey,
        retornaListaPeriodos,
        rotaPeriodoModal,
        useTituloModal,
        cadastroPeriodo,
        edicaoPeriodo,
        duplicacaoPeriodo,
        cadastroEscola
    }
}



